import { StyleSheet } from "react-native";
import { COLORS } from "../../../constants";
export const styles = StyleSheet.create({
    container:{
        paddingTop:20,
        flex:1,
        backgroundColor:COLORS.white
    }
})